module.exports = __webpack_public_path__ + "media/images/img_point3-0a43099662a2c559dcbde430ad726bf2.jpg";